import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
  Box,
  LinearProgress,
  linearProgressClasses,
  List,
  ListItem,
} from '@mui/material';
import Container from '@mui/material/Container';
import { styled } from "@mui/material/styles";
import { ThemeProvider, createTheme } from '@mui/material/styles';
import ActivitiesStyles from './ActivitiesStyles';

const ActivitiesBarGraph = (tab, data) => {

  console.log("data: ", data);

  const lineBarTheme = createTheme({
    palette: {
      primary: {
        light: '#dddddd',
        main: '#dddddd',
        dark: '#dddddd',
        contrastText: '#fff',
      },
      secondary: {
        light: '#6179D3',
        main: '#6179D3',
        dark: '#6179D3',
        contrastText: '#fff',
      },
    },
  });

    let days = {
      seg: 0,
      ter: 0,
      qua: 0,
      qui: 0,
      sex: 0,
      sab: 0,
      dom: 0
    };
  
    let arrayPlace = '';
    switch (tab) {
      case '1': arrayPlace = 'driving'; break;
      case '2': arrayPlace = 'work'; break;
      case '3': arrayPlace = 'pause'; break;
      case '4': arrayPlace = 'other'; break;
      default: arrayPlace = 'driving'; break;
    }

    //VERIFICAR MÁXIMO DE TEMPOS COM A EMPRESA!!!!!!
    //..............................
    //...................................
  
    if (data != null && data.length > 0) {
      data.forEach(day => {
        if (isDateInCurrentWeek(day.workday)) {
          console.log(day.workday);
          switch (getDayOfWeek(day.workday)) {
            case 'Seg': days.seg = (day[arrayPlace] * 100) / (8 * 60); break;
            case 'Ter': days.ter = (day[arrayPlace] * 100) / (8 * 60); break;
            case 'Qua': days.qua = (day[arrayPlace] * 100) / (8 * 60); break;
            case 'Qui': days.qui = (day[arrayPlace] * 100) / (8 * 60); break;
            case 'Sex': days.sex = (day[arrayPlace] * 100) / (8 * 60); break;
            case 'Sab': days.sab = (day[arrayPlace] * 100) / (8 * 60); break;
            case 'Dom': days.dom = (day[arrayPlace] * 100) / (8 * 60); break;
          }
        }
      });
    }

    console.log("days: ", days);
  
    let counter = 0;

    const VerticalLinearProgress = styled(LinearProgress)(() => ({
      width: "7px",
      height: "150px",
      [`& .${linearProgressClasses.bar}`]: {
        backgroundColor: 'primary',
      },
      [`&.${linearProgressClasses.colorSecondary}`]: {
        backgroundColor: 'secondary'
      }
    }));
  
  

  const classes = ActivitiesStyles();

    return (
    <ThemeProvider theme={lineBarTheme}>
      <Container className={classes.verticalLineGraphs}>
      <List id="graphList" className={classes.verticalLineList}>
          
          {<>
        {Object.keys(days).map((day) => {
          counter++;
          return (
            <ListItem key={counter} id={`bar${counter}`} alignItems="center">
              
              <VerticalLinearProgress
                variant="determinate"
                color="secondary"
                value={days[day]}
                sx={{
                  [`& .${linearProgressClasses.bar}`]: {
                    transform: `translateY(${100-days[day]}%)!important`
                  }
                }}
              />
              <div>{day}</div>
            </ListItem>
          );
        })}
      </>}

      </List>
        
      </Container>
    </ThemeProvider>
    
  )};

  function getDayOfWeek(dateString) {
    const date = new Date(dateString);  // Convert the string to a Date object
    const daysOfWeek = ["Seg", "Ter", "Qua", "Qui", "Sex", "Sab", "Dom"];
  
    // Get the day of the week, adjusted to start on Monday
    let dayIndex = date.getDay();       // Get the day of the week (0 = Sunday, 1 = Monday, ..., 6 = Saturday)
    dayIndex = (dayIndex === 0) ? 6 : dayIndex - 1;  // Shift 0 (Sunday) to the end of the week
  
    return daysOfWeek[dayIndex];
}

  
function isDateInCurrentWeek(dateString) {
  const inputDate = new Date(dateString);
  const today = new Date();

  // Get the start of the current week (Monday)
  const startOfWeek = new Date(today);
  const dayOfWeek = today.getDay();
  const daysSinceMonday = (dayOfWeek === 0) ? 6 : dayOfWeek - 1;  // Adjust for Sunday (0) to come after Saturday (6)
  startOfWeek.setDate(today.getDate() - daysSinceMonday);
  startOfWeek.setHours(0, 0, 0, 0);

  // Get the end of the current week (Sunday)
  const endOfWeek = new Date(startOfWeek);
  endOfWeek.setDate(startOfWeek.getDate() + 6);
  endOfWeek.setHours(23, 59, 59, 999);

  // Check if the input date is within the week
  return inputDate >= startOfWeek && inputDate <= endOfWeek;
}

  
  

  export default ActivitiesBarGraph;